import React, { useMemo } from 'react';
import { Chart as ChartJS, BarElement, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(BarElement, LineElement, CategoryScale, LinearScale, PointElement);

const DurationChart = ({ chartData, title }) => {
  const data = {
    labels: ['1', '2', '3', '4', '5', '6'],
    datasets: [
      {
        type: 'bar',
        label: 'Time in Months',
        data: chartData,
        backgroundColor: '#ccf365',
        borderWidth: 1,
      },
      {
        type: 'line',
        label: 'Duration Trend',
        data: chartData,
        borderColor: 'green',
        borderWidth: 2,
        fill: false,
        tension: 0,
        pointBackgroundColor: 'green',
      },
    ],
  };

  const max = useMemo(() => {
    return Math.max(...(chartData || [0])) + 10;
  }, [chartData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        max,
        title: {
          display: true,
          text: 'Time in Months',
          color: 'green',
          font: { size: 14 },
        },
        ticks: { color: 'green' },
      },
      x: {
        title: {
          display: true,
          text: 'Stage',
          color: 'green',
          font: { size: 14 },
        },
      },
    },
    plugins: {
      legend: { display: false },
    },
  };

  return (
    <div className="rounded border-1 p-3 flex flex-col items-center mb-3">
      <h3 className="section-title mb-2">{title}</h3>
      <div className="w-full h-60">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};


export default DurationChart;